import React, { useState, useEffect } from "react";
import {
  getConfirmationsRecord,
  sendConfirmationNotificationEmail,
} from "services/confirmations"
import { Icon, Popup } from "semantic-ui-react"
import Loader from "components/Loader";
import ListTable from "components/Confirmation/ListTable";
import FilterPopup from "components/Confirmation/FilterPopup";
import BookingResultsPopup from "components/Confirmation/BookingResultsPopup";
import FilterBar from "components/Confirmation/FilterBar";
import EditPopup from "components/Confirmation/EditPopup";
import DeletePopup from "components/Confirmation/DeletePopup";
import MessagePopup from "components/MessagePopup";


export default function Confirmation(props:any) {
  // const [initialFetch, setInitialFetch] = useState<boolean>(true)
  const {hotel} = props
  const [loading, setLoading] = useState(false)
  const [fetchCount, setFetchCount] = useState(0)
  const [filter, setFilter] = useState({ notSend: false, filtering: false })
  const [pagination, setPagination] = useState<any>({
    total: null,
    page: 1,
    itemsPerPage: 25,
    totalPages: 1,
    sortBy: "checkInDate.desc",
  })
  const [bookingFilter, setBookingFilter] = useState<any>({
    bookingNumber: null,
    email: null,
    fullName: null,
    firstName: null,
    lastName: null,
  })
  const [confirmations, setConfirmations] = useState<any>(null)
  const [bookings, setBookings] = useState<any>(null)
  const [popup, setPopup] = useState<any>({
    searchBooking: false,
    bookings: false,
    edit: false,
    delete: false,
  })
  const [editRecord, setEditRecord] = useState<object | null>(null)

  /* use for editPopup component to update info */
  const [newConfirmation, setNewConfirmation] = useState({
    email: "",
    phoneNumber: "",
  })

  const [queryString, setQueryString] = useState<any>({
    any: "",
    email: "",
    confirmationNumber: "",
    firstName: "",
    lastName: "",
    checkInDate: "",
  })

  /* for initial get all records */
  useEffect(() => {
    getData()
  }, [fetchCount, pagination.page, pagination.itemsPerPage, pagination.sortBy, queryString.checkInDate])

  const getData = async () => {
    const query = getQueryString()
    setLoading(true)
    const paginationQuery = new URLSearchParams(pagination).toString()
    const { data, pagination: paginationInfo } = await getConfirmationsRecord(`?${[query, paginationQuery].filter(item => item).join('&')}`)
    setPagination((prev: any) => ({ ...prev, ...paginationInfo }))
    setConfirmations([...data])
    setLoading(false)

    // setInitialFetch(false)
  }

  const getQueryString = () => {
    // console.log(queryString) 
    const allEmpty = Object.values(queryString).every((value) => !value)
    // console.log("allEmpty", allEmpty)
    if (allEmpty) return ''

    const queries = Object.keys(queryString)
      .filter(key => {
        return !!queryString[key]
      })
      .map(key => {
        return `"${key}":"${queryString[key]?.trim()}"`
      })
      .join(",")

    // const queries = Object.keys(queryString)
    //   .filter(key => {
    //     return !!queryString[key]
    //   })
    //   .map(key => {
    //     return `${key}=${queryString[key]}`
    //   })
    //   .join("&")

    // console.log("contructed query:", `?${queries}`)

    const conditionJson = queries ? `{${queries}}` : ''
    // console.log("conditionJson",conditionJson)
    return `?filter=${conditionJson}`
  }

  const searchByQueryString = async () => {
    setConfirmations(null)
    await getData()
  }

  const sendConfirmationNotification = async (confirmation: any) => {
    const response = await sendConfirmationNotificationEmail(confirmation)
    // console.log("email response:", response)
    return response
  }

  const updateRecordListByBookingNumber = (bookingNumber: string, newEmail: string): void => {
    if (popup.searchBooking) {
      const index = bookings.findIndex((booking: any) => booking.confirmationNumber === bookingNumber)
      // console.log("??bb",index,newEmail,bookings[index])
      bookings.splice(index, 1, { ...bookings[index], email: newEmail })
      setBookings([...bookings])
    } else {
      const index = confirmations.findIndex((booking: any) => booking.confirmationNumber === bookingNumber)
      // console.log("??aa",index,newEmail,confirmations[index])
      confirmations.splice(index, 1, { ...confirmations[index], email: newEmail })
      setConfirmations([...confirmations])
    }
  }

  return <>
    <MessagePopup />
    {/* popup for enter booking search criteria */}
    <FilterPopup {...{ bookingFilter, setBookingFilter, popup, setPopup, fetchCount, setFetchCount, setBookings }}>
      {/* popup for show the booking search results */}
      <BookingResultsPopup {...{ popup, setPopup, setBookingFilter }} >
        <ListTable
          pagination={pagination}
          setPagination={setPagination}
          hotel={hotel}
          isBooking={true}
          confirmations={confirmations}
          bookings={bookings}
          setBookings={setBookings}
          editRecord={editRecord}
          setEditRecord={setEditRecord}
          popup={popup}
          setPopup={setPopup}
          sendConfirmationNotification={sendConfirmationNotification}
          filter={filter}
          setFilter={setFilter}
          fetchCount={fetchCount}
          setFetchCount={setFetchCount}
          bookingFilter={bookingFilter}
          setBookingFilter={setBookingFilter}
          queryString={queryString}
          setNewConfirmation={setNewConfirmation}
        />
      </BookingResultsPopup>
    </FilterPopup>
    <EditPopup {...{
      hotel:props.hotel,
      updateRecordListByBookingNumber,
      popup,
      setPopup,
      editRecord,
      setEditRecord,
      fetchCount,
      setFetchCount,
      newConfirmation, 
      setNewConfirmation,
    }} />
    <DeletePopup {...{ popup, setPopup, editRecord, fetchCount, setFetchCount }} />
    {
      (!confirmations || loading) ?
        <Loader text="loading..." /> :
        <>
          <FilterBar {...{ queryString, setQueryString, searchByQueryString, setConfirmations, loading, setLoading }} />
          <ListTable
            pagination={pagination}
            setPagination={setPagination}
            hotel={hotel}
            confirmations={confirmations}
            editRecord={editRecord}
            setEditRecord={setEditRecord}
            popup={popup}
            setPopup={setPopup}
            sendConfirmationNotification={sendConfirmationNotification}
            filter={filter}
            setFilter={setFilter}
            fetchCount={fetchCount}
            setFetchCount={setFetchCount}
            bookingFilter={bookingFilter}
            setBookingFilter={setBookingFilter}
            queryString={queryString}
            setNewConfirmation={setNewConfirmation}
          />
        </>
    }

    <Popup content='Search booking records' trigger={
      <div
        className="flex w-12 h-12 rounded-full bg-yellow-300 fixed bottom-10 right-10 cursor-pointer"
        onClick={() => {
          // setFilter({ ...filter, filtering: true })
          setPopup({ ...popup, searchBooking: true })
        }}
      >
        <Icon style={{ margin: "auto" }} color="black" name="search" size="large" />
      </div>
    } />

  </>
}
